import React from 'react';
import s from '../TierBadge.scss';
const Unlocked40 = ({ className  })=>/*#__PURE__*/ React.createElement("svg", {
        className: className,
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("path", {
        opacity: "0.1",
        d: "M19 0.577351C19.6188 0.220085 20.3812 0.220085 21 0.57735L36.3205 9.42265C36.9393 9.77991 37.3205 10.4402 37.3205 11.1547V28.8453C37.3205 29.5598 36.9393 30.2201 36.3205 30.5774L21 39.4226C20.3812 39.7799 19.6188 39.7799 19 39.4226L3.67949 30.5774C3.06069 30.2201 2.67949 29.5598 2.67949 28.8453V11.1547C2.67949 10.4402 3.06069 9.77991 3.67949 9.42265L19 0.577351Z",
        className: s['fill-color']
    }), /*#__PURE__*/ React.createElement("path", {
        opacity: "0.1",
        d: "M19 4.32735C19.6188 3.97008 20.3812 3.97008 21 4.32735L33.0729 11.2977C33.6917 11.6549 34.0729 12.3152 34.0729 13.0297V26.9703C34.0729 27.6848 33.6917 28.3451 33.0729 28.7024L21 35.6727C20.3812 36.0299 19.6188 36.0299 19 35.6726L6.92709 28.7024C6.30828 28.3451 5.92709 27.6848 5.92709 26.9703V13.0297C5.92709 12.3152 6.30828 11.6549 6.92709 11.2976L19 4.32735Z",
        className: s['fill-color']
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M19 8.07735C19.6188 7.72008 20.3812 7.72008 21 8.07735L29.8253 13.1726C30.4441 13.5299 30.8253 14.1902 30.8253 14.9047V25.0953C30.8253 25.8098 30.4441 26.4701 29.8253 26.8274L21 31.9226C20.3812 32.2799 19.6188 32.2799 19 31.9226L10.1747 26.8274C9.55588 26.4701 9.17468 25.8098 9.17468 25.0953V14.9047C9.17468 14.1902 9.55588 13.5299 10.1747 13.1726L19 8.07735Z",
        className: s['fill-color']
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M26.25 16.875L24.8268 25.4144C24.7464 25.8966 24.3292 26.25 23.8404 26.25H16.1596C15.6708 26.25 15.2536 25.8966 15.1732 25.4144L13.75 16.875L17.6562 19.2188L20 13.75L22.3438 19.2188L26.25 16.875Z",
        className: s['bg-color']
    }));
Unlocked40.displayName = 'Unlocked40';
export default Unlocked40;
